import React, { useCallback, useEffect } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
//
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function AdminUserGuard({ children }: Props) {
  const router = useRouter();

  const { isAuthenticated, user } = useAuthContext();

  const check = useCallback(() => {
    if (isAuthenticated && user && !user?.is_admin) {
      console.log(`is user admin? ${user?.is_admin}`)
      console.log(`is user authenticated? ${user?.is_admin}`)
      router.replace(paths.dashboard.root);
    }
  }, [isAuthenticated, router, user]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
